// d:\projetos\www\clinica\admin-clinica\src\pages\onboarding\OnboardingMaterialsPage.js
import '../../styles/OnboardingExperience.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { useEntidadeContext } from '../../EntidadeContext'; // Corrigido o caminho
import { Button, Card, Modal, Form, Spinner, Table, Row, Col, Alert, InputGroup } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';

const OnboardingMaterialsPage = () => {
    const navigate = useNavigate();
    const { completeOnboardingStep } = useAuthContext();
    const { currentEntidade } = useEntidadeContext();

    const [showMaterialModal, setShowMaterialModal] = useState(false);
    const [isLoadingMaterial, setIsLoadingMaterial] = useState(false);
    const [materialSubmitMessage, setMaterialSubmitMessage] = useState(null); // { type: 'success'/'danger', text: '' }
    const [novoMaterial, setNovoMaterial] = useState({
        nome: '',
        descricao: '',
        // 'tipo' não é um campo direto do formulário, 'nome' do material vira o nome do 'tipo_material'
        fornecedor: '',
        lote: '',
        validade: '',
        fabricante: '',
        numero_serie: '',
        quantidade_adquirida: 0,
        valor: 0, // Valor total da aquisição
        valor_unidade: 0, // Calculado
        unidade_medida: '',
        // 'quantidade' não é um campo direto, 'quantidade_adquirida' vira 'quantidade_em_estoque'
    });
    const [materiaisCadastrados, setMateriaisCadastrados] = useState([]);

    // Buscar materiais já cadastrados pela entidade ao carregar (opcional, mas bom para UX)
    useEffect(() => {
        const fetchMateriais = async () => {
            if (currentEntidade?.id) {
                try {
                    // Este endpoint deve retornar os Tipos de Materiais
                    const response = await axios.get(`/api/tipos_materiais?entidade_id=${currentEntidade.id}`);
                    setMateriaisCadastrados(response.data.tipos_materiais || []);
                } catch (error) {
                    console.error("Erro ao buscar materiais cadastrados:", error);
                }
            }
        };
        fetchMateriais();
    }, [currentEntidade]);

    const resetNovoMaterialForm = () => {
        setNovoMaterial({
            nome: '',
            descricao: '',
            fornecedor: '',
            lote: '',
            validade: '',
            fabricante: '',
            numero_serie: '',
            quantidade_adquirida: 0,
            valor: 0,
            valor_unidade: 0,
            unidade_medida: '',
        });
    };

    const handleOpenMaterialModal = () => {
        resetNovoMaterialForm();
        setMaterialSubmitMessage(null);
        setShowMaterialModal(true);
    };

    const handleCloseMaterialModal = () => setShowMaterialModal(false);

    const handleChangeNovoMaterial = (eventOrValue, nameAttr) => {
        const name = nameAttr || eventOrValue.target.name;
        const rawValue = nameAttr ? eventOrValue : eventOrValue.target.value;
 
        setNovoMaterial(prevState => {
            const newState = { ...prevState };
 
            if (name === 'quantidade_adquirida') {
                // Se o campo for limpo, o valor no estado será 0.
                // Se não, converte para inteiro. parseInt lida com "05" -> 5.
                const intValue = parseInt(rawValue, 10);
                newState[name] = isNaN(intValue) ? 0 : intValue;
            } else if (name === 'valor') {
                const cleanedValue = String(rawValue || '').replace(/^0+(?=\d)/, '');
                newState[name] = parseFloat(cleanedValue) || 0;
            } else {
                newState[name] = rawValue;
            }
 
            // Recalcula o valor unitário com os valores atualizados do estado
            const valor = parseFloat(newState.valor) || 0;
            const quantidade = parseFloat(newState.quantidade_adquirida) || 0;
 
            if (quantidade > 0 && valor > 0) {
                newState.valor_unidade = (valor / quantidade).toFixed(2);
            } else {
                newState.valor_unidade = 0;
            }
            return newState;
        });
    };

    const handleSubmitNovoMaterial = async (event) => {
        event.preventDefault();
        setIsLoadingMaterial(true);
        setMaterialSubmitMessage(null);
        if (!currentEntidade?.id) {
            setMaterialSubmitMessage({ type: 'danger', text: 'Entidade não identificada.' });
            setIsLoadingMaterial(false);
            return;
        }

        const dataPayload = {
            ...novoMaterial,
            entidade_id: currentEntidade.id,
            quantidade_em_estoque: novoMaterial.quantidade_adquirida, // Backend espera isso
        };

        try {
            const response = await axios.post(`/api/materiais/criar-com-tipo`, dataPayload);
            // A API /criar-com-tipo deve retornar o tipo_material criado e o item de estoque.
            // Vamos assumir que response.data.tipo_material é o objeto do tipo de material.
            setMateriaisCadastrados(prev => [...prev, response.data.tipo_material]);

            // Mostra uma mensagem de sucesso temporária
            setMaterialSubmitMessage({ type: 'success', text: 'Material salvo com sucesso!' });
            
            // Desativa o spinner para que a mensagem seja visível
            setIsLoadingMaterial(false); 

            // Agenda o fechamento do modal para que o usuário veja a mensagem e a animação
            setTimeout(() => {
                handleCloseMaterialModal();
            }, 1000); // Fecha após 1.5 segundos

        } catch (error) {
            console.error("Erro ao criar material:", error.response?.data || error.message);
            setMaterialSubmitMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao criar material.' });
            setIsLoadingMaterial(false); // Desativa o spinner no erro
        }
    };

    const handleCompleteStep = async () => {
        try {
            const response = await completeOnboardingStep('materials');
            if (response.onboarding_complete) {
                navigate('/dashboard');
            } else if (response.next_step_key === 'pending_services') {
                navigate('/onboarding/services');
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Erro ao completar passo (materiais):", error);
            alert('Erro ao finalizar esta etapa.');
        }
    };

    return (
        <Card className="onboarding-shell onboarding-shell--materials">
            <Card.Body>
                <div className="onboarding-hero">
                    <div className="onboarding-progress"><span>Etapa 1 de 3</span><div className="onboarding-progress__track"><div className="onboarding-progress__bar" style={{ width: '33%' }} /></div></div>
                    <div className="onboarding-hero__row"><div className="onboarding-hero__icon">📦</div><div><span className="onboarding-hero__eyebrow">Seu estoque começa aqui</span><h1>Organize seus materiais</h1><p>Cadastre o essencial agora. Você poderá completar o estoque quando quiser.</p></div></div>
                </div>

                <Alert variant="info" className="onboarding-tip">
                    <Alert.Heading>Por que isso é importante?</Alert.Heading>
                    <p>Cadastrar seus materiais agora permitirá um controle preciso do estoque e dos custos dos seus serviços desde o início. Isso é fundamental para uma gestão financeira saudável!</p>
                    <hr />
                    <p className="mb-0">Adicione pelo menos um material para continuar. Você poderá adicionar mais depois.</p>
                </Alert>

                <div className="d-grid gap-2 my-4">
                    <Button className="onboarding-primary" variant="primary" size="lg" onClick={handleOpenMaterialModal}>
                        Adicionar Novo Material
                    </Button>
                </div>

                {materiaisCadastrados.length === 0 && (
                    <Alert variant="light" className="onboarding-preview mt-4">
                        <Alert.Heading as="h6" className="text-muted">Exemplo de como ficará seu material</Alert.Heading>
                        <Table bordered size="sm" className="onboarding-table mb-0 mt-2 bg-white">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Descrição</th>
                                    <th>Unidade de Medida</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Seringa Descartável</td>
                                    <td>Seringa de 5ml para aplicações</td>
                                    <td>Unidade</td>
                                </tr>
                                <tr>
                                    <td>Ácido Hialurônico</td>
                                    <td>Preenchedor dérmico para harmonização</td>
                                    <td>Ml</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Alert>
                )}

                {materiaisCadastrados.length > 0 && (
                    <>
                        <h5 className="onboarding-section-title">Materiais Adicionados:</h5>
                        <Table striped bordered hover responsive size="sm" className="onboarding-table">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Descrição</th>
                                    <th>Unidade de Medida</th>
                                </tr>
                            </thead>
                            <tbody>
                                {materiaisCadastrados.map((material) => (
                                    <tr key={material.id}>
                                        <td>{material.nome}</td>
                                        <td>{material.descricao}</td>
                                        <td>{material.unidade_medida}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </>
                )}

                <Modal className="onboarding-modal" centered show={showMaterialModal} onHide={handleCloseMaterialModal} size="lg" animation={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Adicionar Novo Material</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {materialSubmitMessage && (
                            <Alert variant={materialSubmitMessage.type} onClose={() => setMaterialSubmitMessage(null)} dismissible>
                                {materialSubmitMessage.text}
                            </Alert>
                        )}
                        <Form onSubmit={handleSubmitNovoMaterial}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="onboardingMaterialNome"><Form.Label>Nome do Material *</Form.Label><Form.Control type="text" name="nome" value={novoMaterial.nome} onChange={handleChangeNovoMaterial} required /></Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="onboardingMaterialUnidade"><Form.Label>Unidade de Medida *</Form.Label><Form.Select name="unidade_medida" value={novoMaterial.unidade_medida} onChange={handleChangeNovoMaterial} required><option value="">Selecione...</option><option value="Unidade">Unidade</option><option value="Grama">Grama</option><option value="Ml">Ml</option><option value="Quilo">Quilo</option><option value="Metro">Metro</option><option value="Metro Cúbico">Metro Cúbico</option></Form.Select></Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3" controlId="onboardingMaterialDescricao"><Form.Label>Descrição</Form.Label><Form.Control as="textarea" rows={2} name="descricao" value={novoMaterial.descricao} onChange={handleChangeNovoMaterial} /></Form.Group>
                            <Form.Group className="mb-3" controlId="onboardingMaterialFabricante">
                                <Form.Label>Fabricante</Form.Label><Form.Control type="text" name="fabricante" value={novoMaterial.fabricante} onChange={handleChangeNovoMaterial} />
                            </Form.Group>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="onboardingMaterialQtdAdquirida"><Form.Label>Quantidade Adquirida *</Form.Label><Form.Control className="no-spinner" type="number" name="quantidade_adquirida" value={novoMaterial.quantidade_adquirida || ''} onChange={handleChangeNovoMaterial} min="0" required /></Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="onboardingMaterialValorTotal"><Form.Label>Valor Total da Aquisição (R$) *</Form.Label><CurrencyInput id="onboardingMaterialValorTotalInput" name="valor" className="form-control" placeholder="R$ 0,00" value={novoMaterial.valor} decimalsLimit={2} decimalSeparator="," groupSeparator="." onValueChange={(value) => handleChangeNovoMaterial(value, 'valor')} required /></Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6, offset: 6 }}>
                                    <Form.Group className="mb-3" controlId="onboardingMaterialValorUnidade">
                                        <Form.Label>Valor por Unidade</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>R$</InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                name="valor_unidade"
                                                value={novoMaterial.valor_unidade}
                                                readOnly
                                                className="bg-light"
                                                aria-describedby="valor-unitario-help"
                                            />
                                        </InputGroup>
                                        <Form.Text id="valor-unitario-help" muted>
                                            Este valor é calculado automaticamente.
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Campos opcionais como Fornecedor, Lote, Validade podem ser adicionados aqui se necessário */}
                            {/*
                            <Form.Group className="mb-3" controlId="onboardingMaterialFornecedor"><Form.Label>Fornecedor</Form.Label><Form.Control type="text" name="fornecedor" value={novoMaterial.fornecedor} onChange={handleChangeNovoMaterial} /></Form.Group>
                            <Form.Group className="mb-3" controlId="onboardingMaterialLote"><Form.Label>Lote</Form.Label><Form.Control type="text" name="lote" value={novoMaterial.lote} onChange={handleChangeNovoMaterial} /></Form.Group>
                            <Form.Group className="mb-3" controlId="onboardingMaterialValidade"><Form.Label>Validade</Form.Label><Form.Control type="date" name="validade" value={novoMaterial.validade} onChange={handleChangeNovoMaterial} /></Form.Group>
                            */}
                            <div className="d-flex justify-content-end">
                                <Button variant="outline-secondary" onClick={handleCloseMaterialModal} className="me-2" disabled={isLoadingMaterial}>
                                    Fechar Janela
                                </Button>
                                <Button variant="success" type="submit" disabled={isLoadingMaterial}>
                                    {isLoadingMaterial ? <Spinner as="span" animation="border" size="sm" /> : 'Salvar Material'}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Button variant="success" onClick={handleCompleteStep} className="onboarding-complete" disabled={materiaisCadastrados.length === 0}>
                    Concluí Cadastro de Materiais e Ir para Serviços
                </Button>
            </Card.Body>
        </Card>
    );
};

export default OnboardingMaterialsPage;
